import * as React from "react";
import { Alert, CircularProgress, Typography } from "@mui/material";
import { useExternalSite } from "./hooks/useExternalSite";
import { RemovalsList } from "../partials/RemovalsList";

export const ExternalDeclarationPage: React.FC = () => {
  const { site, equipments, loading, error, inviteToken } = useExternalSite();

  if (loading) return <CircularProgress sx={{ display: "block", m: "auto" }} />;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!site) return <Alert severity="warning">Site introuvable.</Alert>;

  return (
    <>
      <title>Trackency - Liste de vos declarations</title>
      <Typography variant="h5" gutterBottom>
        Vos declarations — {site.name}
      </Typography>
      <RemovalsList
        siteId={site!.id}
        inviteToken={inviteToken}
        equipments={equipments}
      />
    </>
  );
};
